
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const { State } = namespace("Root");
import { Cart } from "@/types/Cart";

@Component
export default class WizardFooter extends Vue {
  spaceHtml = "&nbsp;";
  current_route: any;
  footer_class = "footer";
  @State("cart") cart!: Cart;

  constructor() {
    super();
    this.current_route = Vue.router.currentRoute.name;
  }

  mounted() {
    this.changeRouteVariable();
  }

  @Watch("$route")
  onPropertyChanged() {
    this.changeRouteVariable();
  }

  get toShowQuoteId(): boolean {
    return this.cart.saved && this.cart.quoteId > 0;
  }

  changeRouteVariable() {
    this.current_route = Vue.router.currentRoute.name;
    if (this.current_route == "home" || this.current_route == "wizard.end") {
      this.footer_class = "footer";
    } else {
      this.footer_class = "footer checkoutfooter";
    }
  }
}
